import { render, staticRenderFns } from "./ModuleCenterPage.vue?vue&type=template&id=0c2fdaa8&scoped=true&"
import script from "./ModuleCenterPage.vue?vue&type=script&lang=js&"
export * from "./ModuleCenterPage.vue?vue&type=script&lang=js&"
import style0 from "./ModuleCenterPage.vue?vue&type=style&index=0&id=0c2fdaa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2fdaa8",
  null
  
)

export default component.exports